// Al clickear el aviso de "agregá N más y pagá X% menos", sube la cantidad
// de esa línea al tramo del descuento y dispara un 'change' real sobre el
// input — el mismo evento que ya escucha cart.js (ver CartItems.onChange),
// así que no hace falta reimplementar el fetch de actualización del carrito.
document.addEventListener('click', function (event) {
  const button = event.target.closest('.cart-quantity-nudge');
  if (!button) return;

  const input = document.getElementById(button.dataset.quantityTarget);
  if (!input) return;

  input.value = button.dataset.quantityValue;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
